// extracted by mini-css-extract-plugin
module.exports = {"span":"styles_span__8J5mY","default":"styles_default__kM0lV","accent":"styles_accent__LCjiS","inverse":"styles_inverse__1AKyG"};